var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-become-agent" }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `padding-top: ${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { title: "", "left-arrow": "" },
          on: { "click-left": _vm.closeWeb },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "left-nav",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow05.png"),
                      alt: "",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _c("div", { staticClass: "main" }, [
      _c("div", { staticClass: "logo" }, [
        _c("img", { attrs: { src: _vm.getMatchImg("app-logo"), alt: "" } }),
        _c("span", [_vm._v(_vm._s(_vm.$t("lang.bc.tit")) + "!")]),
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "text" }, [
          _vm._v("1." + _vm._s(_vm.$t("lang.bc.tit1"))),
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.youFrom,
              expression: "youFrom",
            },
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.youFrom },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.youFrom = $event.target.value
            },
          },
        }),
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "text" }, [
          _vm._v("2." + _vm._s(_vm.$t("lang.bc.tit2"))),
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.theyFrom,
              expression: "theyFrom",
            },
          ],
          attrs: { type: "text", placeholder: _vm.$t("lang.bc.inputTit1") },
          domProps: { value: _vm.theyFrom },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.theyFrom = $event.target.value
            },
          },
        }),
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "text" }, [
          _vm._v("3." + _vm._s(_vm.$t("lang.bc.tit3"))),
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.contact,
              expression: "contact",
            },
          ],
          attrs: { type: "text", placeholder: _vm.$t("lang.bc.inputTit2") },
          domProps: { value: _vm.contact },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.contact = $event.target.value
            },
          },
        }),
      ]),
      _c(
        "div",
        { staticClass: "item" },
        [
          _c("div", { staticClass: "text" }, [
            _vm._v("4." + _vm._s(_vm.$t("lang.bc.tit4"))),
          ]),
          _c("van-uploader", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.s3,
                expression: "s3",
              },
            ],
            attrs: {
              "after-read": _vm.afterRead,
              "max-count": 5,
              multiple: _vm.multiple,
            },
            on: { delete: (file, detail) => _vm.deleteImg(file, detail) },
            model: {
              value: _vm.fileList,
              callback: function ($$v) {
                _vm.fileList = $$v
              },
              expression: "fileList",
            },
          }),
        ],
        1
      ),
      this.code
        ? _c(
            "div",
            {
              class: {
                submit: true,
                submitflag:
                  _vm.youFrom &&
                  _vm.theyFrom &&
                  _vm.contact &&
                  _vm.flag &&
                  _vm.fileList.length > 0,
              },
              on: { click: _vm.handleSubmit },
            },
            [
              _vm.codeFlag
                ? _c("span", [_vm._v(_vm._s(_vm.$t("lang.bc.goInvite")))])
                : _c("span", [_vm._v(_vm._s(_vm.$t("lang.bc.submit")))]),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }